import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.UPDATE_SHIFT_PRIORITY_SETTINGS_BEGIN](state) {
    state.autoschedulingSettingsUpdateState = API_STATES.REQUEST_PENDING;

  },
  [types.UPDATE_SHIFT_PRIORITY_SETTINGS_SUCCESS](state) {
    state.autoschedulingSettingsUpdateError = null;
    state.autoschedulingSettingsUpdateState = API_STATES.REQUEST_SUCCESS;
  },
  [types.UPDATE_SHIFT_PRIORITY_SETTINGS_ERROR](state, err) {
    state.autoschedulingSettingsUpdateState = API_STATES.REQUEST_ERROR;
    state.autoschedulingSettingsUpdateError = err;
  },
};

export default mutations;
